'use strict';

var gtxNotify = require('./gtx-notify'),
    gtxConstants = require('./gtx-constants'),
    $ = require('./jquery-plugins'),
    getPageSnapshot = require('core-utils/modules/functions/browser/page-html-snapshot'),
    swig = require('swig'),
    ImmobiliareFlux = require('immobiliare-flux'),
    Spinner = require('./immobiliare-flux/spinner'),
    ModalTpl = require('core-utils/modules/modal-tpl/js/modal-tpl.js'),
    window = require('window'),
    { trans } = require('./lib/translator'),
    ErrorMessage = require('./form-error-helper-text/js/form-error-helper-text');

function AskHelpView(options) {
    if (!options || !options.submitAction) {
        console.error('AskHelpView: missing submit action param');
    }

    var owner = {},
        helpType = '',
        messageSentAlert = trans('help.message_sent'),
        alerts = {
            success: {
                comment: messageSentAlert,
                customerServiceRequest: trans('help.request_sent')
            },
            error: {
                'defaultMsg': trans('help.error.1'),
                'not-logged': trans('help.error.2'),
                'data-not-validated': trans('help.error.3')
            }
        },
        modalId = 'modal-invio-mail-assistenza',
        spinner,
        root;

    /**
     * @param value
     */
    function setAskHelpType(value) {
        helpType = value;
    }

    /**
     * @returns string
     */
    function getAskHelpType() {
        return helpType;
    }

    /**
     * @returns string
     */
    function getFormTpl() {
        if (!getAskHelpType()) {
            return;
        }

        if (getAskHelpType() === 'customerService' && options && options.external === 'salesforce') {
            return swig.compile(require('../views/snippets/contact-us-salesforce.html.twig'), {locals:{trans}});
        }

        return swig.compile(require('../views/snippets/contattaci-form.html.twig'), {locals:{trans}});
    }

    /**
     *
     * @param type
     */
    function successMessage(type) {
        gtxNotify.success({message: alerts.success[type]});
    }

    function customValidate(form) {
        form.parsley({
            errorClass: 'gx-input--negative',
        });
        form.parsley().on('field:validated', function (fieldInstance) {
            const _this = this;
            const errorStrings = ParsleyUI.getErrorsMessages(fieldInstance);
            const inputWrapper = _this.$element.parents('.gx-input-wrapper');
            const inputTextareaWrapper = _this.$element.parents('.gx-textarea-wrapper');
            const inputSelect = _this.$element.parents('.gx-select');

            // If field is valid
            if (this.validationResult === true) {
                inputWrapper.find('.gx-helper--negative').remove();
                inputTextareaWrapper.find('.gx-helper--negative').remove();

                inputTextareaWrapper.find('.gx-textarea').removeClass('gx-textarea--negative');
                inputSelect.removeClass('gx-select--negative');
            } else {
                $.each(errorStrings, function (key, errorString) {
                    const errorComponent = ImmobiliareFlux.render(
                        ErrorMessage,
                        { errorMessage: errorString }
                    );

                    inputWrapper.find('.gx-helper--negative').remove();
                    inputTextareaWrapper.find('.gx-helper--negative').remove();
                    inputTextareaWrapper.find('.gx-textarea').addClass('gx-textarea--negative');
                    inputSelect.addClass('gx-select--negative');
                    inputTextareaWrapper.append(errorComponent.$el);
                    inputWrapper.append(errorComponent.$el);
                });
            }
        });
    }

    /**
     *
     * @param type
     */
    function errorMessage(type) {
        var msg = alerts.error.hasOwnProperty(type) ? alerts.error[type] : alerts.error.defaultMsg;

        gtxNotify.danger({message: msg});
    }

    /**
     *
     * @returns {{screenSize: string, windowSize: string}}
     */
    function getBrowserInfo() {
        var pageSnap;

        try {
            pageSnap = getPageSnapshot({
                excludeSelector: '#' + modalId + ', .modal-backdrop:last-child'
            });
        } catch (e) {
            pageSnap = 'Abbiamo avuto un errore durante lo snapshot';
        }

        return {
            pageSnapshot: pageSnap,
            screenSize: window.screen.width + 'x' + window.screen.height,
            windowSize: window.innerWidth + 'x' + window.innerHeight
        };
    }

    /**
     *
     * @param $form
     * @returns {*}
     */
    function submitData($form) {
        var data = $.getUrlParams('?' + $form.serialize());
        var url = getAskHelpType() === 'customerService' && options && options.external === 'salesforce' ? '/api/contact-us/send' : '/v2/contattaci/send-email';

        if (!options.external) {
            data = $.extend(data, getBrowserInfo());
        }

        return options.submitAction(url, data).then(
            function () {
                successMessage(data.oggetto);
            }, function (xhr) {
                errorMessage(xhr.responseJSON || {code: 'error'});
                $form.find('[type=submit]').removeClass('disabled');
            }
        );
    }

    function validate(modal) {
        var $form = modal.find('form'),
            parsleyInstance = $form.parsley(),
            result;

        parsleyInstance.validate();
        result = parsleyInstance.isValid();

        if (result) {
            parsleyInstance.reset();
            parsleyInstance.destroy();
        }

        return result;
    }

    /**
     *
     * @param $modal
     * @returns {jQuery}
     */
    function initForm($modal) {
        var $form = $modal.find('form'),
            parsleyFormInstance = $form.parsley({
            errorClass: 'gx-input--negative',
        });

        $form.find('input[data-action="submit"]').on('click', function (evt) {
            evt.preventDefault();


            customValidate($form);
            validate($modal);

            if (parsleyFormInstance.isValid()) {
                $form.find('[type=submit]').addClass('disabled');

                submitData($form).then(
                    function () {
                        $modal.modal('hide');
                    }
                );
            }
        });

        $form.on('reset', function () {
            parsleyFormInstance.reset();
        });

        return $modal;
    }

    /**
     *
     * @param $el
     * @param title
     * @returns {jQuery}
     */
    function showContactForm($el, title) {
        var modal = new ModalTpl();
        var formEntityTplCompiled = getFormTpl();

        modal
            .setModalVar({
                title: title,
                body: formEntityTplCompiled({
                    type: getAskHelpType(), //Chiave utilizzata dal server per riconoscere il tipo di email da inviare. L'elenco di chiavi possibili è presente nella select 'oggetto' del template del form
                    ownerName: owner.name,
                    ownerSurname: owner.surname,
                    ownerEmail: owner.email
                }),
                cssClass: 'fade',
                id: modalId
            })
            .setPreHide(function () {
                $el.removeClass('hidden');
            });

        $el.addClass('hidden');


        return initForm(modal.render());
    }

    /**
     *
     * @param $el
     * @returns {Function}
     */
    function showSuggestForm($el) {
        return function () {
            setAskHelpType('comment');
            return showContactForm($el, trans('help.form.title', {APP_NAME:gtxConstants('APP_NAME')}));
        };
    }

    /**
     *
     * @param $el
     * @returns {Function}
     */
    function showHelpForm($el) {
        return function () {
            setAskHelpType('customerService');
            return showContactForm($el, trans('label.contact_customers_service'));
        };
    }

    /**
     *
     * @param $el
     * @returns {Function}
     */
    function showChatBot($el) {
        return function () {
            __toctoc_agent.show({
                "customerID": gtxConstants('CHAT_BOT_CUSTOMER_ID'),
                "groupID": gtxConstants('CHAT_BOT_GROUP_ID'),
                "language": "it",
                "hideIconize": true,
                "onPreload": function () {
                    spinner.show();
                },
                "onShow": function () {
                    handleChatBotListener($el);
                    $el.addClass('hidden');
                    spinner.hide();
                }
            });

            if(!document.getElementById('__toctoc-live-box-container')) {
                __toctoc_agent.init();
            }
        }
    }

    /**
     *
     * @param $el
     */
    function hideChatBot($el) {
        __toctoc_agent.agent.hide();
        $el.removeClass('hidden');
    }

    /**
     *
     * @param $el
     */
    function handleChatBotListener($el) {
        let closeElement = document.getElementById('__toctoc-action-hangup');
        let closeContactsUsElement = document.getElementById('__toctoc-close');

        if (closeElement) {
            closeElement.onmousedown = null;
            closeElement.addEventListener('mousedown', function () {
                hideChatBot($el);
            }, false);
        }

        if (closeContactsUsElement) {
            let user = document.getElementById('__toctoc_user_name');
            let email = document.getElementById('__toctoc_user_contact');

            if (user) {
                user.value = owner.name + ' ' + owner.surname;
            }

            if (email) {
                email.value = owner.email;
            }

            closeContactsUsElement.onmousedown = null;
            closeContactsUsElement.addEventListener('mousedown', function () {
                hideChatBot($el);
            }, false);
        }
    }

    /**
     *
     * @param $el
     * @returns {Function}
     */
    function addOpacity($el) {
        var timer;

        return function () {
            if (timer) {
                clearTimeout(timer);
            }

            if (!$el.hasClass('scrolling')) {
                $el.addClass('scrolling');
            }

            timer = setTimeout(function () {
                $el.removeClass('scrolling');
            }, 200);
        }
    }

    /**
     *
     * @param evt
     */
    function stopPropagation(evt) {
        evt.stopPropagation();
    }

    /**
     *
     * @param $el
     */
    function initialize($el) {
        let $dropdownElement = $el.find('.dropdown-menu');

        spinner = ImmobiliareFlux.render(Spinner);
        spinner.$el.appendTo($dropdownElement);

        owner.name = $el.data('owner-name');
        owner.surname = $el.data('owner-surname');
        owner.email = $el.data('owner-email');

        $el.find('[data-action=show-help-form]').on('click', showHelpForm($el));
        $el.find('[data-action=show-chat-bot]').on('click', showChatBot($el));
        $el.find('[data-action=show-suggest-form]').on('click', showSuggestForm($el));

        //Disabilito la chiusura del menu al click
        $dropdownElement.on('click', stopPropagation);

        $(window).scrollDebouncer(addOpacity($el));
    }

    root = {
        initialize: initialize
    };

    return root;
}

module.exports = AskHelpView;
